// Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
// See LICENSE in the project root for license information.
var _a, _b;
import os from 'node:os';
import path from 'node:path';
/**
 * The maximum number of concurrent operations to perform.
 */
export const MAX_CONCURRENCY = ((_b = (_a = os.availableParallelism) === null || _a === void 0 ? void 0 : _a.call(os)) !== null && _b !== void 0 ? _b : os.cpus().length) * 2;
/**
 * The name of the action to create symlinks.
 */
export const CREATE_ACTION_NAME = 'create';
/**
 * The name of the action to remove symlinks.
 */
export const REMOVE_ACTION_NAME = 'remove';
/**
 * The name of the parameter to realize files when creating symlinks.
 */
export const REALIZE_FILES_PARAMETER_NAME = '--realize-files';
/**
 * The name of the parameter to link bins when creating symlinks.
 */
export const LINK_BINS_PARAMETER_NAME = '--link-bins';
/**
 * The name of the parameter to link packages when creating symlinks. The actual value of this
 * export is modified after bundling the script to ensure that the extracted version of the script
 * contains the relative path from the extraction target folder to the script. Generally, this
 * value should not be used directly, but rather the `TARGET_ROOT_FOLDER` export should be used
 * instead.
 */
export const TARGET_ROOT_SCRIPT_RELATIVE_PATH = '{TARGET_ROOT_SCRIPT_RELATIVE_PATH}';
/**
 * The path to the root folder where symlinks are created.
 */
export const TARGET_ROOT_FOLDER = path.resolve(__dirname, TARGET_ROOT_SCRIPT_RELATIVE_PATH);
//# sourceMappingURL=constants.js.map